import React from 'react'
import OrgExpenseReport from 'src/app/OrgExpenseReport/OrgExpenseReport'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { orgExpenseReportRouteProps } from 'src/navigation/routeProps'

const OrgExpenseReportAppRoute: AppRoute = {
  id: AppLocation.OrgExpenseReport,
  routeProps: orgExpenseReportRouteProps,
  component: <OrgExpenseReport />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default OrgExpenseReportAppRoute
